import {makeStyles} from "@mui/styles";
import clsx from "clsx";
import React from "react";

const useStyles = makeStyles(
  () => ({
    legalBox: {
      alignItems: "center",
      display: "flex",
      justifyContent: "flex-start",
      padding: "20px 50px",
    },
    root: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "& table": {
        border: "1px solid black",
        borderCollapse: "collapse",
      },
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "& td": {
        border: "1px solid black",
      },
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "& th": {
        border: "1px solid black",
      },
    },
    termsContent: {
      color: "#3E4044",
      fontFamily: "sans-serif",
      fontSize: "16px",
      marginTop: "15px",
      width: "100%",
    },
    termsHeader: {
      color: "#3E4044",
      fontFamily: "sans-serif",
      fontSize: "22px",
      fontWeight: "bold",
    },
    termsSubContent: {color: "#58595e", fontSize: "14px"},
  }),
  {
    name: "Privacy",
  }
);

export const Privacy: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.legalBox}>
      <div className={classes.termsHeader}>
        Privacy Policy
        <div className={classes.termsContent}>
          <br />

          <p className={clsx(classes.root, classes.termsSubContent)}>
            Checkafy, operating by Lever Data Solutions Limited, respects the
            privacy of users of Checkafy Services (the “Services”) on our
            applications and websites (the “Platforms”). We strive to protect
            the privacy of our users in relation to personal data and ensure
            that all our collection, transmission, storage and usage of personal
            data are in compliance with the Personal Data (Privacy) Ordinance,
            Cap. 486 of the laws of the Hong Kong Special Administrative Region
            (the &quot;PDPO&quot;). By providing your personal data to us, you
            are consenting to this Privacy Policy Statement.
          </p>

          <br />

          <p> Purpose of Collection and Use of Personal Data </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            When you access Checkafy Platforms, register with Checkafy or use
            Checkafy Services, personal data are collected from you to enable us
            to provide our Services. You may decline to provide us with the
            requested personal data, but in such case, we may not be able to
            provide our Services to you.
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            Personal data collected from you may be used for without limitation:
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            1) identifying you and any accounts you hold with us;
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            2) enabling the provision of our Services to you;
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            3) making suggestions and recommendations to you of our Services or
            products of our business partners;
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            4) direct marketing of our Services or products of our business
            partners (see the “Direct Marketing” clause below);
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            5) determining and verifying your eligibility for discounts and
            promotions on our Services and products of our business partners;
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            6) conducting research, statistical analyses and behavioural
            analyses;
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            7) conducting program viewership surveys and analyses;
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            8) customer profiling and analysing your purchasing preferences;
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            9) customising our Platforms and Services to your particular
            preferences;
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            10) fraud prevention and detection;
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            11) auditing purposes;
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            12) disclosures as required by applicable laws, rules and
            regulations; and
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            13) any other purposes directly related to the purposes for which
            the personal data were originally collected.
          </p>

          <br />

          <p> Types of Personal Data Collected </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            Personal data collected by Checkafy may include without limitation:
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            1) Your personal information and contact information such as your
            name, gender, date of birth, email address and social media contact;
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            2) Your personal interest;
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            3) Your content viewing habits and transaction patterns; and
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            4) IP address, real-time geographic location data, browsing records,
            and/or other internet log information of your device.
          </p>

          <br />

          <p> Confidentiality, Disclosure and Security of Personal Data </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            All personal data collected and held by Checkafy will be kept
            confidential, but where disclosure is necessary for us to comply
            with any statutory obligations or requirements, or to provide
            Checkafy Services to you, or to carry out the original purposes or
            any other directly related purposes for which the personal data were
            collected, those personal data may be provided to the following
            parties (whether within or outside Hong Kong):
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            1) Competent court of law, law enforcement agencies, or other
            governmental or statutory authorities, institutions or
            organisations;
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            2) Our associated companies, business partners, contractors, agents,
            or other service operators, who are involved in the sales and
            marketing, administration or provision of our Services; and
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            3) Any other person under a duty of confidentiality to us including
            IT consultants, data processors, auditors, accountants, or lawyers,
            who has undertaken to keep such information confidential.
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            Any questions, comments, suggestions or information other than
            personal data sent to or posted on our Platforms will be considered
            as voluntarily provided on a non-confidential and non-proprietary
            basis. We reserve the right to use, reproduce, disclose, transmit,
            publish and/or post elsewhere such information freely, including
            passing it to any associated company, for example, in connection
            with the development and marketing of our Services.
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            We may share non-personal data such as anonymized data and
            aggregated data relating to without limitation purchasing
            preferences and user traffic, publicly and/or with our partners
            including without limitation existing and potential business
            partners, marketing agencies and academics.
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            All personal data held by us are stored in a secure and safe place
            and kept confidential to the best of our ability. However, we cannot
            guarantee the security of transmission.
          </p>

          <br />

          <p> Transfer of Personal Data Outside Hong Kong </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            If necessary, Checkafy may transfer the personal data to places
            outside the Hong Kong Special Administrative Region for carrying out
            the purposes or any other directly related purposes for which the
            personal data were collected. All the transfer of those personal
            data will be carried out in compliance with the PDPO.
          </p>

          <br />

          <p> Retention of Personal Data </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            If you choose, or you are provided with, a user identification code,
            password or any other piece of information as part of our security
            procedures, you must treat such information as confidential. You
            must not disclose it to any third party. You are solely responsible
            for securing your account in this particular way. Checkafy shall
            have no liability to you for any loss or damage in this regard.
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            Unless there is a mandatory legal requirement for us to keep your
            personal data for a specified period, we will only retain your
            personal data for as long as is necessary to fulfil the purposes for
            which the personal data were originally collected.
          </p>

          <br />

          <p> Direct Marketing </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            From time to time, Checkafy may use your personal data to send you
            news, offers, promotions and joint marketing offers, and we require
            your consent for that purpose. We may contact you by email, in-app
            notifications or social media.
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            Your name, gender, date of birth, email address, social media
            contact, personal interests, content viewing habits, transaction
            patterns and other personal data held by us may be used in the
            direct marketing of our Services and the following products offered
            by our business partners, including without limitation: food and
            beverages, groceries, household products, personal care and health,
            skincare and makeup, maternity and baby, pets, electrical
            appliances, housewares and furniture, lifestyle, travel and
            entertainment.
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            If you prefer not to receive any direct marketing communication from
            us or our business partners, you can opt-out at any time by updating
            your preferences through your registered account or an unsubscribe
            link provided. Upon receipt of your request, we shall cease to use
            your personal data for direct marketing as soon as possible without
            charge to you.
          </p>

          <br />

          <p> Links </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            This Privacy Policy Statement only applies to Checkafy Platforms.
            Our Platforms may contain links to other websites. By activating a
            link, you leave our Platforms and we do not exercise control over
            any personal data or any other information you give to any other
            entity after you have left our Platforms. Access to and use of such
            other websites is at your own risk.
          </p>

          <br />

          <p> Data Access, Correction and Deletion </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            If you have any query in relation to Checkafy’s Privacy Policy or
            you wish to access, correct or delete your personal data held by us,
            you may contact us by sending an email to info@checkafy.com.
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            We reserve the right to charge you a reasonable fee for complying
            with a data access request as permitted by the PDPO.
          </p>

          <br />

          <p> General </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            The term &quot;personal data&quot; shall have the meaning ascribed
            to it by the PDPO.
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            Nothing in this Privacy Policy Statement shall limit your rights
            under the PDPO.
          </p>

          <p className={clsx(classes.root, classes.termsSubContent)}>
            We reserve the right at any time without notice to revise this
            Privacy Policy Statement. Any changes to this Privacy Policy
            Statement will be posted on our Platforms.
          </p>

          <br />

          <p className={clsx(classes.root, classes.termsSubContent)}>
            {" "}
            Last Updated: 1 December 2021{" "}
          </p>
        </div>
      </div>
    </div>
  );
};
